import { render, staticRenderFns } from "./ServiceDetailHeader.vue?vue&type=template&id=0fa9da49&"
import script from "./ServiceDetailHeader.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports